
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import PqtMeasurementSpecifications from '../edit/PqtMeasurementSpecifications';
import { PqtMeasurementSpecificationTemplate } from '../../backend/backendapi';
import MeasurementSpecificationTemplateMedias from './MeasurementSpecificationTemplateMedias';

@Component({
  components: {
    MeasurementSpecificationTemplateMedias,
    PqtMeasurementSpecifications,
  },
})
export default class MeasurementSpecificationTemplateEditor extends Vue {
  @Prop({ default: true })
  readonly template!: PqtMeasurementSpecificationTemplate;
  @Prop({ default: true })
  readonly editable!: boolean;
}
